'use strict';
module.exports = function onetimePassword() {
	const s4 = function () {
		const rand = (1 + Math.random());
		return ((rand * 0x10000) || 0).toString(16).substring(1);
	};

	return s4() + '-' + s4();
};
